export enum FileType {
	XLS = 'xls',
	PNG = 'png',
	PDF = 'pdf',
	XLSX = 'xlsx',
	JPG = 'jpg',
	JPEG = 'jpeg',
}

export interface AttachedFile {
	id: string;
	name: string;
	type: FileType;
	uploadedAt: Date;
}

export interface SuggestionCardData {
	id: string;
	icon: React.ReactNode;
	label: string;
	action?: () => void;
}

export interface FloraAICredits {
	used: number;
	total: number;
	renewDate: string;
	planName: string;
}

export interface FloraDossierDocument {
	id: string;
	name: string;
	pages: number;
}

export interface FloraHeroTopic {
	id: string;
	number: string;
	label: string;
}

export interface FloraAIChat {
	id: string;
	title: string;
	lastMessage: string;
	timestamp: Date;
	dossierCount: number;
}

export interface FloraAIChatGroup {
	label: string;
	chats: FloraAIChat[];
}

export interface FloraLibraryFilter {
	id: string;
	label: string;
}

export type FloraLibraryDocumentKind = 'pdf' | 'sheets' | 'images';

export interface FloraLibraryDocument {
	id: string;
	name: string;
	kind: FloraLibraryDocumentKind;
	meta: string;
	inDossier: boolean;
}
